import { ref, onMounted, onBeforeUnmount } from 'vue';

/**
 * Advances an index through `count` items every `interval` ms, starting at 0.
 * `select(i)` jumps to an item and stops the automatic cycling.
 * Given an `el` template ref, it only cycles while that element crosses the middle
 * of the viewport, and the current item gets a full `interval` each time it comes back.
 */
export function useAutoCycle(count, interval = 5000, el = null) {
    const index = ref(0);
    let timer = null;
    let selected = false;
    let observer = null;

    const pause = () => clearInterval(timer);
    const play = () => {
        pause();
        if (selected) return;
        timer = setInterval(() => {
            index.value = (index.value + 1) % count;
        }, interval);
    };
    const select = (i) => {
        selected = true;
        pause();
        index.value = i;
    };

    onMounted(() => {
        if (!el) {
            play();
            return;
        }
        // The root shrinks to a line across the middle of the viewport.
        observer = new IntersectionObserver(([entry]) => (entry.isIntersecting ? play() : pause()), {
            rootMargin: '-50% 0px',
        });
        observer.observe(el.value);
    });
    onBeforeUnmount(() => {
        pause();
        if (observer) observer.disconnect();
    });

    return { index, select };
}
